/**
 * Shared client for the anonymizer API (smile-anonymizer-api), which is now
 * OIDC-protected with roles. The bearer token is read from the oidc-client
 * user in sessionStorage so components don't each need the auth context.
 */

// oidc-client stores the user under "oidc.user:<authority>:<client_id>"
function currentUser() {
    try {
        const key = `oidc.user:${window._env_.REACT_APP_SSO_URL}:${window._env_.REACT_APP_CLIENT_ID}`;
        const raw = sessionStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch (e) {
        return null;
    }
}

export function currentRoles() {
    const user = currentUser();
    const token = user && user[window._env_.REACT_APP_OIDC_TOKEN];
    if (!token) return [];
    try {
        const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
        return (payload.realm_access && payload.realm_access.roles) || [];
    } catch (e) {
        return [];
    }
}

export const isAdmin = () => currentRoles().includes(window._env_.REACT_APP_ROLE_ADMIN || 'smileconceal-admin');
export const isAgent = () => {
    const roles = currentRoles();
    return roles.includes(window._env_.REACT_APP_ROLE_AGENT || 'smileconceal-agent') || isAdmin();
};

/** fetch against the anonymizer API with the bearer token attached */
export function anonApi(path, options = {}) {
    const user = currentUser();
    const token = user && user[window._env_.REACT_APP_OIDC_TOKEN];
    const headers = { ...(options.headers || {}) };
    if (token) {
        headers.Authorization = 'Bearer ' + token;
    }
    return fetch(`${window._env_.REACT_APP_ANONYMIZER_API_URL}${path}`, { ...options, headers })
        .then(async (res) => {
            const data = await res.json().catch(() => ({}));
            if (!res.ok) {
                throw new Error(data.error || `${res.status} ${res.statusText}`);
            }
            return data;
        });
}
